export default __webpack_public_path__ + "static/media/stage2_documents_4.f5571d3b.png";